// @flow

import styled from 'styled-components';

export const ErrorLabel = styled.span`
  color: ${props => props.theme.colors.error(51)};
  font-size: 0.9rem;
  font-weight: bold;
  display: block;
  margin-top: 4px;
`;
